import Utils from '../utils/utils';
import {gsap, Expo} from 'gsap';
import emitter from 'tiny-emitter/instance';

class SearchBar {

  constructor() {

    this.$openBtn = document.querySelector('.navbar-search')
    this.$modalSearch = document.querySelector('.searchBar')
    this.$navbar = document.querySelector('.navbar')

    this.$closeBtn = document.querySelector('.searchBar-close')
    this.$cleanBtn = document.querySelectorAll('.searchBar-delete')
    this.$inputSearch = document.querySelectorAll('input#search')
    this.searchLabel = document.querySelector('.searchform__label')
    this.isOpen = false
    this.tl = gsap.timeline()
    if (!this.$openBtn || !this.$cleanBtn) {
      console.error("Err: No open or clean button (for searchbar)")
      return;
    }
    this.bindEvents()
  }

  bindEvents() {
    this.open()
    this.close()
    this.clean()
  }

  open() {
    this.$openBtn.addEventListener('click', () => {
      console.log(this.isOpen)
      if(!this.isOpen) {
        if (this.$navbar.classList.contains('menu-open')){
          emitter.emit('openSearchBar')
        }
        this.tl.clear()
        this.tl.fromTo(this.$modalSearch, {display: 'none', yPercent: 100}, {display: 'block', yPercent: 0}, "openModal")
        this.tl.fromTo(this.$closeBtn, {y: 100, duration: .5}, {y: 0, ease: Expo.easeOut}, "openModal+=0.5")
        this.tl.fromTo(this.$cleanBtn, {y: 100, duration: .5}, {y: 0, ease: Expo.easeOut}, "openModal+=0.75")
        this.tl.fromTo(this.searchLabel, {y: 100, duration: .5}, {y: 0, ease: Expo.easeOut}, "openModal+=0.85")
        this.isOpen = true
      }
    })
  }

  close() {
    this.$closeBtn.addEventListener('click', () => {
      if(this.isOpen) {
        gsap.to(this.$modalSearch, {display: 'none', yPercent: 100})
        this.isOpen = false
      }
    })
  }

  clean() {
    this.$cleanBtn.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.$inputSearch[index].value = ''
      })
    })

  }
}

export default SearchBar



// WEBPACK FOOTER //
// ./scripts/interface/searchBar.js